import {
  Box,
  Button,
  Divider,
  Grid,
  Pagination,
  Stack,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import { useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // import first
import PageContainer from 'src/components/container/PageContainer';
// components
import { IconDownload } from '@tabler/icons';
import moment from 'moment';
import { TailSpin } from 'react-loader-spinner';
import { adminAxiosInstance } from 'src/api/axios';
import useFileJobs from 'src/hooks/useFileJobs';
import AdminFilterBox from './AdminFilterBox';
import CSVButton from './components/CSVButton';
import LeadsHistory from './components/LeadsHistoryTable';

const selectors = {
  product_id: 'title',
  user_id: 'user_id',
};
const AdminLeadsHistory = () => {
  const [leads, setLeads] = useState([]);
  const [leadCounter, setLeadCounter] = useState({
    count: 0,
    completed: 0,
    incomplete: 0,
  });
  const [mainLeads, setMainLeads] = useState([]);
  const [parsedLeads, setParsedLeads] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [limit, setLimit] = useState(50);
  const [csvLimit, setCsvimit] = useState(500);
  const [hasReportPerm, setHasReportPerm] = useState(true);

  //Bar Charts
  const [searchFilter, setSearchFilter] = useState('');
  const [filter, setFilter] = useState('');
  const [page, setPage] = useState(1);
  const [userId, setUserId] = useState('');
  const [userName, setuserName] = useState('');
  const [productId, setProductId] = useState('');
  const [leadId, setLeadId] = useState('');
  const [userNumber, setUserNumber] = useState('');
  const [firstDateFilter, setfirstDateFilter] = useState(moment());
  const [secondDateFilter, setsecondDateFilter] = useState(moment().add(-2, 'day'));

  const { createFileJob } = useFileJobs();
  const theme = useTheme();

  useMemo(() => {
    try {
      const store = localStorage.getItem('store');
      if (store) {
        const user = JSON.parse(store)?.user;
        const perms = user?.permissions || [];
        const isSuperAdmin = user?.role === 'super_admin';
        setHasReportPerm(isSuperAdmin || perms.includes('view_leads'));
      }
    } catch (e) {
      console.error('Error checking permissions:', e);
    }
  }, []);

  const fetchData = (resetPage = false) => {
    setLoaded(true);
    adminAxiosInstance
      .get(
        `/ref/history?dateStart=${secondDateFilter}&dateEnd=${firstDateFilter}&status=${filter}&user_id=${userId}&product_id=${productId}&user_name=${userName}&user_number=${userNumber}&lead_id=${leadId}&page=${page}&limit=${limit}`,
      )
      .then((response) => {
        if ('status' in response && response.status === 200) {
          console.log(response.data);
          setLoaded(false);
          const { count, leads, paid, due, rejected, totalLeads } = response.data;
          setLeadCounter({
            totalLeads,
            count,
            completed: paid,
            incomplete: due,
            rejected,
          });
          setMainLeads(leads.filter((i) => i.user_id && i.product_id));
          setLeads(leads.filter((i) => i.user_id && i.product_id));
          if (resetPage) {
            setPage(1);
          }
        }
      })
      .catch((e) => {
        setLoaded(false);
        console.log(e);
        setLeadCounter({ count: 0, completed: 0, incomplete: 0 });
        setMainLeads([]);
        setLeads([]);
        // alert('Something went wrong')
      });
  };
  useMemo(() => {
    fetchData();
  }, [filter, page]);

  // useMemo(() => {
  //   let new_leads = leads.filter((i) =>
  //     utils
  //       .generate_regex(searchFilter.toLowerCase())
  //       .test(
  //         i &&
  //           searchSelector in i &&
  //           i[searchSelector] &&
  //           selectors[searchSelector] in i[searchSelector] &&
  //           i[searchSelector][selectors[searchSelector]].toLowerCase(),
  //       ),
  //   );
  //   new_leads = new_leads.filter((i) => i.status === filter);
  //   if (new_leads && new_leads.length) {
  //     console.log(new_leads);

  //     setLeads(new_leads);
  //   } else {
  //     setLeads(mainLeads.filter((i) => i.status === filter));
  //   }
  // }, [searchFilter]);

  // useMemo(() => {
  //   let temp = [];
  //   for (let i of leads) {
  //     temp.push({
  //       id: i?._id || i?.id,
  //       date: i.last_updated_date,
  //       user: i?.user_id?.user_id || '',
  //       username: i?.user_id?.name || '',
  //       campaign: i?.product_id?.title || '',
  //       clicked: i.clicked.length,
  //       total_conversion: i.total_conversion,
  //       redirect_url: i.redirect_url,
  //       status: i.status,
  //       'Customer Name': i?.parameters?.name || i?.parameters?.Name,
  //       'Customer Number': i?.parameters?.number || i?.parameters?.Number,
  //       'Customer Pincode':
  //         i?.parameters?.pincode ||
  //         i?.parameters[
  //           Object.keys(i.parameters).filter((i) => i.toLowerCase().includes('pincode'))
  //         ],
  //       due_payment: i.due_payment,
  //       paid: i.paid,
  //     });
  //   }
  //   setParsedLeads(temp);
  // }, [leads]);

  const parse_leads = (lead) => {
    let temp_obj = JSON.parse(JSON.stringify(lead));

    temp_obj = temp_obj.map((i) => {
      i['campaign'] = i['product_id']['title'];
      delete i['product_id'];
      delete i['__v'];
      delete ['date_created'];

      delete i['redirect_url'];
      delete i['expiry'];
      delete i['clicked'];
      delete i['lead_url'];
      i['_id'] = i?._id || i?.id || '';
      i['sub_lead_id'] = i?.sub_lead_id || '';
      i['EP_id'] = i?.user_id?.user_id || '';
      i['name'] = i['parameters']['Name'] || i['parameters']['name'];
      i['number'] = i['parameters']['Number'] || i['parameters']['number'];
      i['Area Pincode'] = i['parameters']['Area Pincode'];
      i['earnType'] = i['earntype'];
      i['base_amount'] = i['base_amount'] || '';
      i['currentLevel'] = typeof i?.currentLevel === 'number' ? i.currentLevel : 0;
      // Action Header + Action Message as separate columns (mirrors the table).
      // Only for Due / Paid / Complete leads, from levelMeta at current level.
      const ACTION_STATUSES = ['due', 'paid', 'complete', 'completed'];
      const meta = ACTION_STATUSES.includes(String(i?.status || '').toLowerCase())
        ? (i?.levelMeta || []).find((m) => m?.level === i?.currentLevel)
        : null;
      if (meta) {
        i['Action Header'] = meta.action_header || i?.action_header || '-';
        i['Action Message'] = `title: ${meta.title || ''} | description: ${meta.description || ''}`;
      } else {
        i['Action Header'] = '-';
        i['Action Message'] = '-';
      }
      delete i['parameters'];
      delete i['user_id'];
      delete i['levelMeta'];
      delete i['earntype'];

      // Format every date/datetime column into human-readable
      // "Day Month YY, hour:minute". last_updated_date/date_created are stored
      // already IST-shifted -> format as-is; all other date columns are true UTC
      // and get +5:30 to show IST wall-clock.
      const preShifted = ['last_updated_date', 'date_created'];
      const isDateLike = (v) =>
        v instanceof Date ||
        (typeof v === 'string' &&
          (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(v) ||
            /^[A-Za-z]{3} [A-Za-z]{3} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT/.test(v)));
      for (const key of Object.keys(i)) {
        const v = i[key];
        if (isDateLike(v)) {
          const d = v instanceof Date ? v : new Date(v);
          if (!isNaN(d.getTime())) {
            const m = preShifted.includes(key) ? moment.utc(d) : moment.utc(d).add(330, 'minutes');
            i[key] = m.format('DD MMM YY, HH:mm');
          }
        }
      }

      return i;
    });
    // temp_obj[0] = {...temp_obj[0],paid:leadCounter?.completed, due:leadCounter?.incomplete}
    return temp_obj;
  };

  const handleAsyncExport = async () => {
    if (exporting) return;

    setExporting(true);
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
    const fileName = `leads_${timestamp}`;

    try {
      const filters = {
        dateStart: secondDateFilter,
        dateEnd: firstDateFilter,
        status: filter || undefined,
        user_id: userId || undefined,
        product_id: productId || undefined,
        user_name: userName || undefined,
        user_number: userNumber || undefined,
        lead_id: leadId || undefined,
        limit: csvLimit || 500,
      };

      const result = await createFileJob({
        fileName,
        fileType: 'leads_csv',
        filters,
      });

      if (result.success) {
        toast.success('CSV export started! Check File Jobs page for progress.');
      } else {
        toast.error('Failed to start export');
      }
    } catch (error) {
      console.error('Error starting export:', error);
      toast.error('Failed to start export');
    } finally {
      setExporting(false);
    }
  };

  const FilterMap = [
    {
      type: 'text',
      name: 'user Id',
      state: userId,
      setState: setUserId,
      function: () => {
        fetchData(true);
      },
    },
    {
      type: 'text',
      name: 'Lead Id',
      state: leadId,
      setState: setLeadId,
      function: () => {
        fetchData(true);
      },
    },
    {
      type: 'text',
      name: 'Customer Name',
      state: userName,
      setState: setuserName,
      function: () => {
        fetchData(true);
      },
    },
    {
      type: 'text',
      name: 'Customer Number',
      state: userNumber,
      setState: setUserNumber,
      function: () => {
        fetchData(true);
      },
    },
    {
      type: 'text',
      name: 'Product Name',
      state: productId,
      setState: setProductId,
      function: () => {
        fetchData(true);
      },
    },

    {
      type: 'dropdown',
      name: 'Type',
      state: filter,
      setState: setFilter,
      defaultValue: '',
      items: [
        {
          value: '',
          value_label: 'all',
        },
        {
          value: 'completed',
          value_label: 'Completed',
        },
        {
          value: 'incomplete',
          value_label: 'InComplete',
        },
        {
          value: 'due',
          value_label: 'Due',
        },
        {
          value: 'rejected',
          value_label: 'Rejected',
        },
      ],
    },
    {
      type: 'date',
      dateStart: firstDateFilter,
      dateEnd: secondDateFilter,
      setDateStart: setfirstDateFilter,
      setDateEnd: setsecondDateFilter,
      function: () => {
        fetchData(true);
      },
    },
  ];

  return (
    <PageContainer
      title="Lead History | EarnPati"
      description="this is Earnpati Leads History Page"
      sx={{ maxWidth: { xs: '100vw', lg: '70vw' } }}
    >
      <Grid container spacing={1} sx={{ padding: '0 .5rem' }}>
        <Stack
          direction={'row'}
          flexWrap={'wrap'}
          spacing={2}
          justifyContent={'space-between'}
          p={2}
          sx={{
            bgcolor: theme.palette.background.main,
            width: '100%',
            borderRadius: 8,
          }}
          boxShadow={10}
        >
          <Box
            boxShadow={5}
            sx={{
              p: 3,
              borderRadius: 8,
              color: theme.palette.background.dark,
              minWidth: '170px',
              border: `5px solid ${theme.palette.earnpati.main}`,
            }}
          >
            <Typography variant="h4" height={'50%'} sx={{ textAlign: 'center' }}>
              Total Leads
            </Typography>
            <Typography
              variant="h6"
              sx={{
                textAlign: 'center',
                p: 1,
                mt: 2,
                bgcolor: theme.palette.secondary.light,
                color: '#333',
                borderRadius: 3,
              }}
            >
              {
                //   originalLead?.filter(
                //   (l) => l?.product_id && l?.product_id.status.toLowerCase().includes('active'),
                // )?.length || 0
                // leadCounter.count
                leadCounter && leadCounter.count ? leadCounter.count : 0
              }
            </Typography>
          </Box>
          <Box
            boxShadow={5}
            sx={{
              p: 3,
              borderRadius: 8,
              color: theme.palette.background.dark,
              minWidth: '170px',
              border: `5px solid ${theme.palette.earnpati.main}`,
            }}
          >
            <Typography variant="h4" height={'50%'} sx={{ textAlign: 'center' }}>
              Paid
            </Typography>
            <Typography
              variant="h6"
              sx={{
                textAlign: 'center',
                p: 1,
                mt: 2,
                bgcolor: theme.palette.secondary.light,
                color: '#333',
                borderRadius: 3,
              }}
            >
              {
                //   originalLead?.filter(
                //   (l) => l?.product_id && l?.product_id.status.toLowerCase().includes('active'),
                // )?.length || 0
                leadCounter.completed
              }
            </Typography>
          </Box>
          <Box
            boxShadow={5}
            sx={{
              p: 3,
              borderRadius: 8,
              color: theme.palette.background.dark,
              minWidth: '170px',
              border: `5px solid ${theme.palette.earnpati.main}`,
            }}
          >
            <Typography variant="h4" height={'50%'} sx={{ textAlign: 'center' }}>
              Incomplete
            </Typography>
            <Typography
              variant="h6"
              sx={{
                textAlign: 'center',
                p: 1,
                mt: 2,
                bgcolor: theme.palette.secondary.light,
                color: '#333',
                borderRadius: 3,
              }}
            >
              {
                //   originalLead?.filter(
                //   (l) => l?.product_id && l?.product_id.status.toLowerCase().includes('active'),
                // )?.length || 0
                leadCounter.incomplete
              }
            </Typography>
          </Box>
          <Box
            boxShadow={5}
            sx={{
              p: 3,
              borderRadius: 8,
              color: theme.palette.background.dark,
              minWidth: '170px',
              border: `5px solid ${theme.palette.earnpati.main}`,
            }}
          >
            <Typography variant="h4" height={'50%'} sx={{ textAlign: 'center' }}>
              Rejected
            </Typography>
            <Typography
              variant="h6"
              sx={{
                textAlign: 'center',
                p: 1,
                mt: 2,
                bgcolor: theme.palette.secondary.light,
                color: '#333',
                borderRadius: 3,
              }}
            >
              {
                //   originalLead?.filter(
                //   (l) => l?.product_id && l?.product_id.status.toLowerCase().includes('active'),
                // )?.length || 0
                leadCounter?.rejected || 0
              }
            </Typography>
          </Box>
        </Stack>
        <Grid item xs={12} my={2}>
          <AdminFilterBox
            inputs={FilterMap}
            submitFunction={fetchData}
            sx={{ top: '70px', background: '#fff', zIndex: 10 }}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              my: 1,
            }}
          >
            <Stack direction="row" justifyContent={'space-between'} sx={{ width: '100%' }}>
              <p>
                Showing data of past:{' '}
                {parseInt(moment.duration(firstDateFilter - secondDateFilter).asDays() || 0)} days
              </p>
              <Stack direction={'row'}>
                <p sx={{ mt: '15px' }}>Limit:</p>
                <TextField
                  sx={{ width: '25%', margin: '5px' }}
                  type="number"
                  placeholder={`Limit`}
                  value={csvLimit}
                  onChange={(e) => setCsvimit(e.target.value)}
                />
                {hasReportPerm && (
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={exporting ? <TailSpin height={16} width={16} /> : <IconDownload />}
                    onClick={handleAsyncExport}
                    disabled={exporting}
                    sx={{ ml: 1 }}
                  >
                    {exporting ? 'Exporting...' : 'Export CSV (Async)'}
                  </Button>
                )}
                <CSVButton
                  transformer={parse_leads}
                  csv_download_url={`/ref/history_bulk?dateStart=${secondDateFilter}&dateEnd=${firstDateFilter}&status=${filter}&user_id=${userId}&product_id=${productId}&user_name=${userName}&user_number=${userNumber}&limit=${csvLimit}`}
                  filename={`leads_${filter}_${new Date().toDateString()}.csv`}
                  csvData={parsedLeads}
                  setCsvData={setParsedLeads}
                />
              </Stack>
            </Stack>
          </Box>

          <Divider sx={{ my: 1 }} />
          <Box>
            {(leads?.length && <LeadsHistory details={leads} loaded={loaded} />) || (
              <Stack
                justifyContent={'center'}
                alignItems={'center'}
                sx={{ width: '75vw', height: '30vh' }}
              >
                <Typography variant="h4" sx={{ textAlign: 'center' }}>
                  No Data Found
                </Typography>
              </Stack>
            )}
          </Box>
          <Stack
            direction="row"
            alignItems={'center'}
            justifyContent={'center'}
            sx={{
              position: 'fixed',
              bottom: 0,
              right: 0,
              p: 2,
              background: theme.palette.success.light,
              color: theme.palette.earnpati.main,
              width: '80%',
            }}
          >
            <Pagination
              count={Math.round(leadCounter?.totalLeads ? leadCounter?.totalLeads / limit : 1) || 1}
              onChange={(e, value) => setPage(value)}
            ></Pagination>
          </Stack>
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default AdminLeadsHistory;
